import {
  getApiStatistics,
  getApiStatisticsAuthors,
  getApiStatisticsTracks,
} from '@/shared/api'
import { type ElementType, type EventOrCallableType } from '@/shared/lib/utils'
import { createQuery } from '@farfetched/core'

export const getStatisticsAppQuery = createQuery({
  handler: getApiStatistics,
})

type GetStatisticsCommonQueryStart = EventOrCallableType<
  typeof getStatisticsAppQuery.start
>

export const getStatisticsTracksQuery = createQuery({
  handler: getApiStatisticsTracks,
})

export type GetStatisticsTracksQueryStart = EventOrCallableType<
  typeof getStatisticsTracksQuery.start
>

export type GetStatisticsTracksQueryFinishedSuccess = EventOrCallableType<
  typeof getStatisticsTracksQuery.finished.success
>

export type GetStatisticsTracksQueryFinishedSuccessResult =
  GetStatisticsTracksQueryFinishedSuccess['result']
export type GetStatisticsTracksQueryFinishedSuccessResultTracksItem =
  ElementType<
    NonNullable<
      GetStatisticsTracksQueryFinishedSuccessResult['tracks']
    >['items']
  >

export const getStatisticsAuthorsQuery = createQuery({
  handler: getApiStatisticsAuthors,
})

export type GetStatisticsAuthorsQueryStart = EventOrCallableType<
  typeof getStatisticsAuthorsQuery.start
>

export type GetStatisticsAuthorsQueryFinishedSuccess = EventOrCallableType<
  typeof getStatisticsAuthorsQuery.finished.success
>

export type GetStatisticsAuthorsQueryFinishedSuccessResult =
  GetStatisticsAuthorsQueryFinishedSuccess['result']

export type GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem =
  ElementType<
    NonNullable<
      GetStatisticsAuthorsQueryFinishedSuccessResult['authors']
    >['items']
  >

export type GetStatisticsQueryStartCommon = {
  params: Pick<
    | NonNullable<GetStatisticsCommonQueryStart['params']>
    | GetStatisticsTracksQueryStart['params']
    | GetStatisticsAuthorsQueryStart['params'],
    'StartDate' | 'EndDate' | 'GetForAllTime'
  >
}
